<template>
  <div id="app">
    <header-child></header-child>
    <router-view/>
    <navFooter :isShow="isShow"></navFooter>
    <div class="empty-footer-div"></div>
  </div>
</template>
<script>
import HeaderChild from '@/components/HeaderChild'
import navFooter from '@/components/navFooter'
export default {
  name: 'App',
  data () {
    return {
      ico:'http://www.stackoverflow.com/favicon.ico',
      mobile_domain:'',
      isShow: this.$route.path === '/index.html' ? true : false
    }
  },
  components: {
    navFooter,
    HeaderChild
  },
  watch: {
      $route(to,from){
        this.getConfig();

        this.isShow = this.$route.path === '/index.html' ? true : false;
      }
  },
  methods:{
    getConfig(){
      this.$axios.post(this.api.index.index,{},res =>{
          this.ico=res.data.logo;
          var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = this.ico;
          document.getElementsByTagName('head')[0].appendChild(link);
          this.$store.dispatch('setGroupLogo',res.data.group_logo);
          this.$store.dispatch('setCopyright',res.data.copyright);

          this.$store.dispatch('setIcpRecord',res.data.icp_record);
          this.$store.dispatch('setPoliceRecord',res.data.police_record);
          this.$store.dispatch('setPoliceRecordNumber',res.data.police_record_number);

          this.mobile_domain=res.data.mobile_domain;
          var pcflag=this.IsPC();
          if(!pcflag){
            var mobile_path;
            if(this.$route.path == '/aboutBranch'||this.$route.path == '/aboutHonor'){
              mobile_path='http://'+this.mobile_domain+'/index.html';
            }
            else if(this.$route.path == '/aboutContactUs'){
              mobile_path='http://'+this.mobile_domain+'/aboutUS.html';
            }
            else{
              mobile_path='http://'+this.mobile_domain+this.$route.fullPath;
            }
            window.location.href=mobile_path;
          }
        });  
    },
    IsPC(){  
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");  
      var flag = true;  
      for (var v = 0; v < Agents.length; v++) {  
        if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }  
      }  
      return flag;  
    }
  },
  created(){
    this.getConfig();
  }
}
</script>
<style>
html,body{height:100%;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height:100%;
  position:relative;
}
.empty-footer-div{height:240px;}
.app *{box-sizing: border-box}
.toolbar{text-align: center;position: relative;}
.header-empty{
  height:100px;
}
.empty-header-div{height:100px;}
.el-pagination .el-pager li.active {
    color: #fff !important;
    background-color: #0D3482 !important;
    border-radius: 5px;
    min-width: 28px}
</style>


// WEBPACK FOOTER //
// src/App.vue